import { Box, Stack, Typography } from "@mui/material";
import LlmProviderConnectionRow from "./LlmProviderConnectionRow";
import { useLlmProviderConnections } from "./useLlmProviderConnections";

const providers = ["openai", "anthropic", "gemini", "xai"];

const providerLabels = {
  openai: "OpenAI",
  anthropic: "Anthropic",
  gemini: "Google",
  xai: "Grok",
};

export default function LlmProviderConnections() {
  const { connections, keys, revoke, save, setKey } =
    useLlmProviderConnections();
  const connected = new Set(
    connections.filter((row) => row.connected).map((row) => row.provider),
  );
  return (
    <Box component="section" sx={{ mt: 3 }}>
      <Typography variant="h6">AI provider keys</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Personal keys are encrypted and take precedence over workspace-managed
        access.
      </Typography>
      <Stack spacing={1.5}>
        {providers.map((provider) => (
          <LlmProviderConnectionRow
            key={provider}
            provider={provider}
            label={providerLabels[provider]}
            connected={connected.has(provider)}
            value={keys[provider] ?? ""}
            onChange={setKey}
            onSave={save}
            onRevoke={revoke}
          />
        ))}
      </Stack>
    </Box>
  );
}
